import { render, staticRenderFns } from "./TypeSaleOrderStatus.vue?vue&type=template&id=d37d333a&"
import script from "./TypeSaleOrderStatus.vue?vue&type=script&lang=js&"
export * from "./TypeSaleOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports